import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const WishlistShareBarContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex: 1;
    gap: ${({ theme }) => theme.spacing.medium};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    position: ${({ theme }) => theme.style.position.absolute};
    justify-content: ${({ theme }) => theme.style.justifyContent.flexEnd};
    width: 100%;
    padding: 0 16px;
    top: 62px;
    z-index: 1;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 100%;
        max-width: 68.625rem;
        padding: ${props => `${props.theme.spacing.xxSmall} ${props.theme.spacing.large}`};
        top: 166px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
    }
`
